import _classCallCheck from "/pubskape-frontend/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/pubskape-frontend/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/pubskape-frontend/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/pubskape-frontend/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/pubskape-frontend/node_modules/@babel/runtime/helpers/esm/inherits";
import { __rest } from "tslib";
import * as React from 'react';
import styles from '@patternfly/react-styles/css/components/Dropdown/dropdown';
import { DropdownContext } from './dropdownConstants';
import { css } from '@patternfly/react-styles';
import { KEY_CODES } from '../../helpers/constants';
var buttonVariantStyles = {
  default: '',
  primary: styles.modifiers.primary,
  secondary: styles.modifiers.secondary
};
export var Toggle =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Toggle, _React$Component);

  function Toggle() {
    var _this;

    _classCallCheck(this, Toggle);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Toggle).apply(this, arguments));
    _this.buttonRef = React.createRef();

    _this.componentDidMount = function () {
      document.addEventListener('click', _this.onDocClick);
      document.addEventListener('touchstart', _this.onDocClick);
      document.addEventListener('keydown', _this.onEscPress);
    };

    _this.componentWillUnmount = function () {
      document.removeEventListener('click', _this.onDocClick);
      document.removeEventListener('touchstart', _this.onDocClick);
      document.removeEventListener('keydown', _this.onEscPress);
    };

    _this.onDocClick = function (event) {
      var _this$props = _this.props,
          isOpen = _this$props.isOpen,
          parentRef = _this$props.parentRef,
          onToggle = _this$props.onToggle,
          getMenuRef = _this$props.getMenuRef;
      var menuRef = getMenuRef && getMenuRef();
      var clickedOnToggle = parentRef && parentRef.current && parentRef.current.contains(event.target);
      var clickedWithinMenu = menuRef && menuRef.contains && menuRef.contains(event.target);

      if (isOpen && !(clickedOnToggle || clickedWithinMenu)) {
        onToggle(false, event);
      }
    };

    _this.onEscPress = function (event) {
      var _this$props2 = _this.props,
          parentRef = _this$props2.parentRef,
          getMenuRef = _this$props2.getMenuRef;
      var keyCode = event.keyCode || event.which;
      var menuRef = getMenuRef && getMenuRef();
      var escFromToggle = parentRef && parentRef.current && parentRef.current.contains(event.target);
      var escFromWithinMenu = menuRef && menuRef.contains && menuRef.contains(event.target);

      if (_this.props.isOpen && (keyCode === KEY_CODES.ESCAPE_KEY || event.key === 'Tab') && (escFromToggle || escFromWithinMenu)) {
        _this.props.onToggle(false, event);

        _this.buttonRef.current.focus();
      }
    };

    _this.onKeyDown = function (event) {
      if (event.key === 'Tab' && !_this.props.isOpen) {
        return;
      }

      if ((event.key === 'Tab' || event.key === 'Enter' || event.key === ' ') && _this.props.isOpen) {
        if (!_this.props.bubbleEvent) {
          event.stopPropagation();
        }

        event.preventDefault();

        _this.props.onToggle(!_this.props.isOpen, event);
      } else if ((event.key === 'Enter' || event.key === ' ') && !_this.props.isOpen) {
        if (!_this.props.bubbleEvent) {
          event.stopPropagation();
        }

        event.preventDefault();

        _this.props.onToggle(!_this.props.isOpen, event);

        _this.props.onEnter();
      }
    };

    return _this;
  }

  _createClass(Toggle, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _a = this.props,
          className = _a.className,
          children = _a.children,
          isOpen = _a.isOpen,
          isDisabled = _a.isDisabled,
          isPlain = _a.isPlain,
          isPrimary = _a.isPrimary,
          isSplitButton = _a.isSplitButton,
          toggleVariant = _a.toggleVariant,
          onToggle = _a.onToggle,
          ariaHasPopup = _a['aria-haspopup'],
          isActive = _a.isActive,
          bubbleEvent = _a.bubbleEvent,
          onEnter = _a.onEnter,
          parentRef = _a.parentRef,
          getMenuRef = _a.getMenuRef,
          id = _a.id,
          type = _a.type,
          props = __rest(_a, ["className", "children", "isOpen", "isDisabled", "isPlain", "isPrimary", "isSplitButton", "toggleVariant", "onToggle", 'aria-haspopup', "isActive", "bubbleEvent", "onEnter", "parentRef", "getMenuRef", "id", "type"]);

      return React.createElement(DropdownContext.Consumer, null, function (_ref) {
        var toggleClass = _ref.toggleClass;
        return React.createElement("button", Object.assign({}, props, {
          id: id,
          ref: _this2.buttonRef,
          className: css(isSplitButton ? styles.dropdownToggleButton : toggleClass || styles.dropdownToggle, isActive && styles.modifiers.active, isPlain && styles.modifiers.plain, isPrimary && styles.modifiers.primary, buttonVariantStyles[toggleVariant], className),
          type: type || 'button',
          onClick: function onClick(event) {
            return onToggle(!isOpen, event);
          },
          "aria-expanded": isOpen,
          "aria-haspopup": ariaHasPopup,
          onKeyDown: function onKeyDown(event) {
            return _this2.onKeyDown(event);
          },
          disabled: isDisabled
        }), children);
      });
    }
  }]);

  return Toggle;
}(React.Component);
Toggle.displayName = 'Toggle';
Toggle.defaultProps = {
  className: '',
  isOpen: false,
  isActive: false,
  isDisabled: false,
  isPlain: false,
  isPrimary: false,
  isSplitButton: false,
  onToggle: function onToggle() {},
  onEnter: function onEnter() {},
  bubbleEvent: false
};